import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Serializes flat query parameters with spaces as `%20`, not `+`: the
 * third-party address-lookup API is not relied on to decode `+`.
 */
export function toQueryString(
  params: Record<string, string | number | boolean>,
): string {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    search.append(key, String(value))
  }
  return search.toString().replace(/\+/g, '%20')
}
